import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import CommHubIndicator from './components/CommHubIndicator';
import './index.css';
import SubscriptionGate from './components/SubscriptionGate';
import { getAppPricing } from './config/pricing-config';

// Use comm-hub pricing for quantrolix-saas
const appPricing = getAppPricing('comm-hub');

// Initialize Sentry for crash reporting
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE || 'production',
    release: `quantrolix-saas@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
    tracesSampleRate: 0.2,
  });
}

class RootErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[QuantrolixAI Root Crash]', error, errorInfo);
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo?.componentStack } } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0e1a', color: '#fff', fontFamily: 'system-ui', padding: '2rem' }}>
          <div style={{ maxWidth: '500px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#00d4ff' }}>QuantrolixAI</h1>
            <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#9ca3af' }}>The application encountered an unexpected error.</p>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '0.75rem 2rem', background: '#00d4ff', color: '#0a0e1a', border: 'none', borderRadius: '0.5rem', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer' }}
            >
              Reload Application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <SubscriptionGate appId="quantrolix-saas" pricing={appPricing}>
        <App />
        <CommHubIndicator project="quantrolix-saas" />
      </SubscriptionGate>
    </RootErrorBoundary>
  </React.StrictMode>
);
